import { cloneDeep } from 'lodash'
import { CHART_PREFERENCES_DEFAULT_VALUES } from '../../components/screens/Explorer/DrawerTabs/StyleTab/styleConsts'

// Default chart style preferences as a JSON string (dark variant swaps the axis/text greys).
// Moved from StyleTab/utils.jsx so chart code can use it without the UI component library.
export const getDefaultChartPreferences = (darkTheme) => {
    const themeString = JSON.stringify(cloneDeep(CHART_PREFERENCES_DEFAULT_VALUES))
    if (darkTheme)
        return themeString.replaceAll('#6E7079', '#FFFFFF').replaceAll('#000000FF', '#FFFFFF')
    return themeString
}
